import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Alert, AlertService } from '../../services/alert.service';

@Component({
    selector: 'app-alert-toaster',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './alert-toaster.html',
    styleUrls: ['./alert-toaster.scss']
})
export class AlertToasterComponent implements OnInit, OnDestroy {
    alerts: Alert[] = [];
    private subscription!: Subscription;

    constructor(private alertService: AlertService) {}

    ngOnInit(): void {
        this.subscription = this.alertService.alerts$.subscribe(
            (alerts) => this.alerts = alerts
        );
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    dismiss(id: string): void {
        this.alertService.dismiss(id);
    }

    getIcon(type: string): string {
        switch (type) {
            case 'success': return 'check_circle';
            case 'danger': return 'error';
            case 'warning': return 'warning';
            case 'info': return 'info';
            default: return 'info';
        }
    }
}
